.noPermission {
	display: flex;
	justify-content: center;
}

.container {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.description {
	margin: 0;
	color: #4b5563;
	font-size: 14px;
	line-height: 1.5;
}

.fileInput {
	display: none;
}

.fileLabel {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 10px 16px;
	border: 1px dashed #9ca3af;
	border-radius: 8px;
	cursor: pointer;
	color: #374151;
	font-size: 14px;
	background: #f9fafb;
}

.fileLabel:hover {
	border-color: #7fb02f;
	color: #4d7c0f;
}

.summary {
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 12px;
	border-radius: 8px;
	background: #f3f4f6;
	font-size: 14px;
}

.summarySuccess {
	color: #166534;
}

.summaryError {
	color: #b91c1c;
}

.errorsList {
	max-height: 180px;
	overflow-y: auto;
	margin: 0;
	padding-left: 18px;
	font-size: 13px;
	color: #991b1b;
}

.previewIds {
	max-height: 120px;
	overflow-y: auto;
	font-size: 12px;
	color: #6b7280;
	word-break: break-all;
}
